import { PosButton } from '@/components/ui'

/** Previous / next for a 50-row server list. */
export const Pager = ({ page, count, onChange, length = 50 }: { page: number; count: number; onChange: (page: number) => void; length?: number }) => {
  const pages = Math.max(1, Math.ceil(count / length))
  if (pages <= 1) return null
  return (
    <div className="flex items-center justify-end gap-2">
      <PosButton variant="outline" disabled={page <= 1} onClick={() => onChange(page - 1)}>
        Previous
      </PosButton>
      <span className="text-xs text-muted-foreground">
        Page {page} of {pages}
      </span>
      <PosButton variant="outline" disabled={page >= pages} onClick={() => onChange(page + 1)}>
        Next
      </PosButton>
    </div>
  )
}
